module.exports = __webpack_public_path__ + "static/img/Visualization14.9ef71e82.png";